module.exports = __webpack_public_path__ + "img/DownloadCN.1e192fb8.png";